var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwindCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#38bdf8",
    d: "M12 4.5c-3.5 0-5.7 1.75-6.5 5.25 1.3-1.75 2.8-2.4 4.5-2 1 .25 1.7 1 2.5 1.8 1.4 1.5 3.2 3.45 6.5 3.45 3.5 0 5.7-1.75 6.5-5.25-1.3 1.75-2.8 2.4-4.5 2-1-.25-1.7-1-2.5-1.8C16.6 6.45 14.8 4.5 11.5 4.5H12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0ea5e9",
    d: "M12 10.5c-3.5 0-5.7 1.75-6.5 5.25 1.3-1.75 2.8-2.4 4.5-2 1 .25 1.7 1 2.5 1.8 1.4 1.5 3.2 3.45 6.5 3.45 3.5 0 5.7-1.75 6.5-5.25-1.3 1.75-2.8 2.4-4.5 2-1-.25-1.7-1-2.5-1.8-1.4-1.5-3.2-3.45-6.5-3.45H12Z",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindCss);
export default __webpack_public_path__ + "static/media/tailwind-css.d5e3af46bc075de88f2dd79fb1d69ecb.svg";
export { ForwardRef as ReactComponent };